export default __webpack_public_path__ + "static/media/sample1.e0c3b4ff.png";